window.$ = window.jQuery = require("jquery");

define(function(){

    require("framework/core/proto");
    let config = require("data/config");
    let binder = require("framework/binder");

    let init = function() {

        let triggers = [
            require("trigger/confirm"),
            require("trigger/window"),
            require("trigger/tooltip"),
            require("trigger/formAjax"),
            require("trigger/loader"),
            require("trigger/popover"),
            require("trigger/clipboard"),
        ];

        let components = [
            require("component/availabilityForm"),
            require("component/companySelector"),
            require("component/dialog--paymentDialog"),
            require("component/summary--auto"),
            require("component/uiButtonSwitch--tab"),
            require("component/uiInput"),
            require("component/uiInputOption"),
            require("component/uiInputStepper"),
            require("component/uiInputToggler"),
            require("component/uiInputWrapper--stepper"),
            require("component/attendees-filter"),
            require("component/applicationForm"),
            require("component/upgradesForm"),
            require("component/navigationTabs"),
            require("component/leadScanner"),
            require("component/exhibitorMeetingForm"),
            require("component/discountBox"),
            require("component/survey"),
            require("component/feedbackMessage"),
        ];

        for(var i = 0; i<triggers.length; i++) {
            binder.bindOnce(config.prefixes.trigger, triggers[i].name, triggers[i].apply, triggers[i].defaultParameters);
        }

        for(var i = 0; i<components.length; i++) {
            binder.bindOnce(config.prefixes.component, components[i].name, components[i].apply, components[i].defaultParameters);
        }
    };

    $(window).on(config.events.significantDomChange,init);
    init();

});
